// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workforce-analytics-header {
  flex-wrap: wrap;
}

.workforce-chart-controls {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.workforce-chart-controls label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #667085;
  font-size: 9px;
  font-weight: 800;
}

.workforce-chart-controls select {
  min-width: 150px;
  height: 38px;
  padding: 0 10px;
  border: 1px solid #ddd6fe;
  border-radius: 9px;
  background: #fff;
  color: #344054;
  outline: 0;
}

@media (max-width: 760px) {
  .workforce-chart-controls {
    width: 100%;
    margin-left: 0;
  }

  .workforce-chart-controls label {
    flex: 1 1;
  }

  .workforce-chart-controls select {
    width: 100%;
    min-width: 0;
  }
}

.workforce-category-switch{display:flex;align-items:center;gap:3px;margin:0;padding:3px;border:1px solid #ddd6fe;border-radius:10px;background:#f8f7ff}
.workforce-category-switch legend,.workforce-category-switch input{position:absolute;width:1px;height:1px;overflow:hidden;opacity:0}
.workforce-category-switch label{display:block}
.workforce-category-switch span{display:block;padding:8px 10px;border-radius:7px;color:#667085;cursor:pointer;white-space:nowrap}
.workforce-category-switch label.active span{background:#5b35f5;color:#fff;box-shadow:0 3px 8px rgba(91,53,245,.25)}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/workforceSubmissionControls.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,2BAA2B,YAAY,CAAC,kBAAkB,CAAC,OAAO,CAAC,QAAQ,CAAC,WAAW,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,kBAAkB;AACtJ,mEAAmE,iBAAiB,CAAC,SAAS,CAAC,UAAU,CAAC,eAAe,CAAC,SAAS;AACnI,iCAAiC,aAAa;AAC9C,gCAAgC,aAAa,CAAC,gBAAgB,CAAC,iBAAiB,CAAC,aAAa,CAAC,cAAc,CAAC,kBAAkB;AAChI,6CAA6C,kBAAkB,CAAC,UAAU,CAAC,wCAAwC","sourcesContent":[".workforce-analytics-header {\n  flex-wrap: wrap;\n}\n\n.workforce-chart-controls {\n  display: flex;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.workforce-chart-controls label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: #667085;\n  font-size: 9px;\n  font-weight: 800;\n}\n\n.workforce-chart-controls select {\n  min-width: 150px;\n  height: 38px;\n  padding: 0 10px;\n  border: 1px solid #ddd6fe;\n  border-radius: 9px;\n  background: #fff;\n  color: #344054;\n  outline: 0;\n}\n\n@media (max-width: 760px) {\n  .workforce-chart-controls {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .workforce-chart-controls label {\n    flex: 1;\n  }\n\n  .workforce-chart-controls select {\n    width: 100%;\n    min-width: 0;\n  }\n}\n\n.workforce-category-switch{display:flex;align-items:center;gap:3px;margin:0;padding:3px;border:1px solid #ddd6fe;border-radius:10px;background:#f8f7ff}\n.workforce-category-switch legend,.workforce-category-switch input{position:absolute;width:1px;height:1px;overflow:hidden;opacity:0}\n.workforce-category-switch label{display:block}\n.workforce-category-switch span{display:block;padding:8px 10px;border-radius:7px;color:#667085;cursor:pointer;white-space:nowrap}\n.workforce-category-switch label.active span{background:#5b35f5;color:#fff;box-shadow:0 3px 8px rgba(91,53,245,.25)}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
